module.exports = __webpack_public_path__ + "1710bd14fb77947ba2d57e9aff235832.svg";